import React, { Component } from 'react';
import machines from '../../../services/api/machines';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Card } from 'react-bootstrap';
import socketIo from 'socket.io-client';
import realtime from '../../../services/api/realtime';
import api from '../../../services/api/api';
import { withTranslation } from 'react-i18next';

class MMULogAndControl extends Component {
	state = {
		commandText: '',
		logs: []
	};

	currentStartIndex = 0;
	recordsPerLoad = 5;
	hasMoreRecords = true;
	socket = null;

	componentDidMount() {
		this.loadLogs();
		this.subscribeToLogs();
	}

	componentWillUnmount() {
		this.unsubscribeFromLogs();
	}

	subscribeToLogs() {
		const token = api.getToken();
		if (!token) {
			return;
		}

		this.socket = socketIo(process.env.REACT_APP_BACKEND_WEBSOCKET_SERVER, {
			transports: ['websocket']
		});

		this.socket.on('connect', () => {
			this.socket.emit('subscribe', `mmu/${this.props.partID}/logs`, token);
		});

		this.socket.on('message', (data) => {
			this.state.logs.unshift({ ...data });
			this.setState({ logs: this.state.logs });
		});
	}

	unsubscribeFromLogs() {
		this.socket.disconnect();
	}

	async loadLogs() {
		const response = await machines.getHardwarePartLogs(
			this.props.partID,
			this.currentStartIndex,
			this.recordsPerLoad
		);
		if (
			!response.data ||
			!response.data.logs ||
			response.data.logs.length === 0
		) {
			this.hasMoreRecords = false;
			return;
		}
		this.hasMoreRecords = response.data.logs.length >= this.recordsPerLoad;

		this.setState((prevState) => ({
			logs: [...prevState.logs, ...response.data.logs]
		}));
		this.currentStartIndex += response.data.logs.length;
	}

	sendCommand() {
		// Implement command sending logic here
		realtime.sendMMUCommand(
			this.props.serialNumber,
			this.state.commandText,
			api.getToken()
		);
		this.setState({ commandText: '' });
	}

	render() {
		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%'
				}}
			>
				<InfiniteScroll
					dataLength={this.state.logs.length}
					next={() => this.loadLogs()}
					hasMore={this.hasMoreRecords}
					loader={<h4>Loading...</h4>}
					endMessage={
						<p style={{ textAlign: 'center' }}>
							<b>
								{this.props.t(
									'hardwareManagement.hardwareHistory.logAndControl.noMoreEntry'
								)}
							</b>
						</p>
					}
					refreshFunction={() => this.loadLogs()}
					pullDownToRefresh
					pullDownToRefreshThreshold={50}
					height={400}
					style={{
						flex: 1,
						overflow: 'hidden',
						marginBottom: '10px',
						flexGrow: 1
					}}
				>
					{this.state.logs.map((log, index) => (
						<Card key={index}>
							<Card.Body>
								<Card.Title>
									{new Date(log.insertedAt).toLocaleString()}
								</Card.Title>
								<Card.Text>{log.logEntry}</Card.Text>
							</Card.Body>
						</Card>
					))}
				</InfiniteScroll>

				<div
					style={{
						display: 'flex',
						gap: '10px',
						padding: '10px',
						borderTop: '1px solid #ddd',
						backgroundColor: '#f8f9fa'
					}}
				>
					<textarea
						name="CommandString"
						cols="40"
						rows="5"
						type="text"
						placeholder="Enter command"
						style={{
							flex: 1,
							padding: '8px 12px',
							border: '1px solid #ccc',
							borderRadius: '4px',
							fontSize: '14px'
						}}
						value={this.state.commandText}
						onChange={(e) => this.setState({ commandText: e.target.value })}
					></textarea>
					<button
						style={{
							padding: '8px 16px',
							backgroundColor: '#007bff',
							color: 'white',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer',
							fontSize: '14px'
						}}
						onClick={() => this.sendCommand()}
					>
						{this.props.t(
							'hardwareManagement.hardwareHistory.logAndControl.sendCommand'
						)}
					</button>
				</div>
			</div>
		);
	}
}

export default withTranslation()(MMULogAndControl);
